module.exports = "https://images.rbxcdn.com/c343f87e315da7537604e45fe3e50d23-PlatformEventLeftNav_EN.jpg";